import { handleResponse, handleError } from "./apiUtils";
import config from "../config";
//const baseUrl = "/api";
//const upload = "/upload";

export function uploadfile(data) {
  console.log("uploadfile data:", data);
  const uploadFileUrl = config.UploadFileToSharepoint_URL;
  return fetch(uploadFileUrl, {
    method: "POST",
    body: data,
  })
    .then(handleResponse)
    .catch(handleError);
}
